import React from 'react'

import Form from 'react-bootstrap/Form'

const NOTE_MAX = 1000

export default function InvoiceEmailNote({
  value,
  onChange,
  subjectLabel,
  isDisabled = false,
}) {
  return (
    <Form.Group className="form-group" controlId="invoiceEmailNote">
      <Form.Label>Invoice email note</Form.Label>
      <p className="text-muted mb-2">
        Shown under the Pay Now button when an invoice for this {subjectLabel}{' '}
        is emailed. The email already names this {subjectLabel}. Type{' '}
        <code>{'{{name}}'}</code> anywhere you want that name repeated. Leave
        blank to send the standard invoice email.
      </p>
      <Form.Control
        as="textarea"
        rows={4}
        name="invoiceEmailNote"
        maxLength={NOTE_MAX}
        disabled={isDisabled}
        placeholder="If you wish to pay by cash or check, visit the office or call this number to schedule a time."
        value={value || ''}
        onChange={onChange}
      />
    </Form.Group>
  )
}
